import { FlagOutlined, TaskAltOutlined } from "@mui/icons-material";
import { Divider, Stack, Typography } from "@mui/material";
import { CreatedItemListItem } from ".";
import { IssueListItemSkeleton, TaskItemListItemSkeleton } from "../../../../components";
import { SupportingItemType } from "../../../../constants";
import { useGetCreatedItemsFromResponseAnswer } from "../../../../http";

interface IProps {
  responseAnswerGuid: string;
  loadingEnabled: boolean;
  onItemClick: () => void;
}

const CreatedItemsPopoverContent = (props: IProps) => {
  const { isLoading, data } = useGetCreatedItemsFromResponseAnswer(props.responseAnswerGuid, props.loadingEnabled);

  return (
    <Stack spacing={1} sx={{ minWidth: "500px", py: 1 }}>
      <Stack>
        <Typography variant="overline" sx={{ mx: 1, my: 0 }}>
          <FlagOutlined fontSize="small" sx={{ alignSelf: "center", mr: 0.5 }} />
          Issues
        </Typography>
        <Stack divider={<Divider variant="dashed" sx={{ mx: 1 }} />}>
          {isLoading || !data ? (
            <IssueListItemSkeleton sx={{ width: "100%", px: 1 }} />
          ) : data.issues.length > 0 ? (
            data.issues.map((issue) => (
              <CreatedItemListItem
                key={issue.guid}
                item={issue}
                itemType={SupportingItemType.Issue}
                responseAnswerGuid={props.responseAnswerGuid}
                sx={{ px: 1 }}
                onItemClicked={() => props.onItemClick()}
              />
            ))
          ) : (
            <Typography variant="placeholder" sx={{ px: 1, pt: 0.5 }}>
              Nothing here yet.
            </Typography>
          )}
        </Stack>
      </Stack>
      <Stack spacing={0}>
        <Typography variant="overline" sx={{ mx: 1, my: 0 }}>
          <TaskAltOutlined fontSize="small" sx={{ alignSelf: "center", mr: 0.5 }} />
          Tasks
        </Typography>
        <Stack divider={<Divider variant="dashed" sx={{ mx: 1 }} />}>
          {isLoading || !data ? (
            <TaskItemListItemSkeleton sx={{ width: "100%", px: 1 }} />
          ) : data.taskItems.length > 0 ? (
            data.taskItems.map((taskItem) => (
              <CreatedItemListItem
                key={taskItem.guid}
                item={taskItem}
                itemType={SupportingItemType.TaskItem}
                responseAnswerGuid={props.responseAnswerGuid}
                sx={{ px: 1 }}
                onItemClicked={() => props.onItemClick()}
              />
            ))
          ) : (
            <Typography variant="placeholder" sx={{ px: 1, pt: 0.5 }}>
              Nothing here yet.
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export { CreatedItemsPopoverContent };
